import { render, staticRenderFns } from "./SideMenuHeaderButton.vue?vue&type=template&id=e4d9c288"
import script from "./SideMenuHeaderButton.vue?vue&type=script&lang=ts"
export * from "./SideMenuHeaderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports